export * from '@primeuix/themes/nora/inputchips';
export { default } from '@primeuix/themes/nora/inputchips';
